import React, { useState } from "react";
import { DateRangePickerButton } from "shared/DateRangePickerButton/DateRangePickerButton";
import CalendarEventsList from "./CalendarEventsList";
import styles from "./CalendarPage.module.css";
import CreateNewCalendarEventModal from "./CreateNewCalendarEventModal";
import CalendarEventDates from "./CalendarEventDates";

export function CalendarPage({ meetingType }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [createNewModalOpen, setCreateNewModalOpen] = useState(false);

  const testCalendarEvents = [
    {
      date: "22 April",
      time: "2-2:45 MST",
      location: "Spokane, Washington",
      name: "Spokane calendar event",
    },
    {
      date: "07 May",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Phoenix calendar event",
    },
    {
      date: "09 June",
      time: "2-2:45 MST",
      location: "Spokane, Washington",
      name: "Spokane calendar event",
    },
    {
      date: "30 July",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Cool event name",
    },
    {
      date: "02 July",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "04 July",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "10 July",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "08 August",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "20 August",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Phoenix calendar event",
    },
    {
      date: "09 September",
      time: "2-2:45 MST",
      location: "Spokane, Washington",
      name: "Spokane calendar event",
    },
    {
      date: "27 September",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Cool event name",
    },
    {
      date: "18 October",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "29 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Phoenix calendar event",
    },
    {
      date: "09 December",
      time: "2-2:45 MST",
      location: "Spokane, Washington",
      name: "Spokane calendar event",
    },
    {
      date: "29 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Cool event name",
    },
    {
      date: "29 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "29 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Phoenix calendar event",
    },
    {
      date: "09 December",
      time: "2-2:45 MST",
      location: "Spokane, Washington",
      name: "Spokane calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Cool event name",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
    {
      date: "30 December",
      time: "All Day",
      location: "Phoenix, Arizona",
      name: "Name of calendar event",
    },
  ];

  // Get an array of all event dates
  const eventDates = testCalendarEvents.map((event) => {
    const [day, month] = event.date.split(" ");
    const year = new Date().getFullYear();
    return new Date(`${month} ${day}, ${year}`);
  });

  function onCreate(data) {
    setCreateNewModalOpen(false);
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>CALENDAR</h1>
      <CreateNewCalendarEventModal
        onCreate={onCreate}
        isOpen={createNewModalOpen}
        onClose={() => setCreateNewModalOpen(false)}
      />
      <div className={styles.headerContainer}>
        <div className={styles.rangeRow}>
          <div>
            <h4>Date Range</h4>
          </div>
          <div className={styles.rangePicker}>
            <DateRangePickerButton
              startDateString={startDate}
              endDateString={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
        </div>
        <div
          className={styles.button}
          onClick={() => setCreateNewModalOpen(true)}
        >
          ADD EVENT
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.date}>
          <CalendarEventDates allowPastDate={true} eventsDate={eventDates} />
        </div>
        <div className={styles.item}>
          <CalendarEventsList calendarEvents={testCalendarEvents} />
        </div>
      </div>
    </div>
  );
}
